import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import qs from "query-string";

import SessionFormInput from "@ats/src/views/sessions/components/SessionFormInput";
import FormContainer from "@ats/src/components/forms/FormContainer";
import SessionButton from "@ats/src/views/sessions/components/SessionButton";
import Styled from "@ats/src/views/sessions/components/Styled";
import FormLogoHeader from "@ats/src/views/sessions/components/FormLogoHeader";
import SessionsLayout from "@ats/src/views/sessions/components/SessionsLayout";

import { useToastContext } from "@shared/context/ToastContext";
import { useResetPassword } from "@shared/queryHooks/useSession";
import { validatePassword } from "@shared/lib/validateWithYup";

function PasswordReset(props) {
  const [errors, setErrors] = React.useState(null);
  const [password, setPassword] = React.useState("");
  const [passwordConfirmation, setPasswordConfirmation] = React.useState("");
  const [resetPasswordToken, setResetPasswordToken] = React.useState("");
  const addToast = useToastContext();

  const { mutate: resetPassword, isLoading } = useResetPassword();

  React.useEffect(() => {
    addResetPasswordTokenFromParams();
  }, []);

  /* Add the Reset Password Token from URL
  --===================================================-- */
  const addResetPasswordTokenFromParams = () => {
    const token = qs.parse(props.location.search).reset_password_token;

    if (token) {
      setResetPasswordToken(token);
    }
  };

  const handleFormInputChange = (name, value) => {
    setErrors(null);
    if (name === "password") {
      setPassword(value);
    } else if (name === "passwordConfirmation") {
      setPasswordConfirmation(value);
    }
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    window.logger("%c[PasswordReset] handleSubmitForm", "color: #1976D2", {
      password,
      passwordConfirmation,
      resetPasswordToken,
    });

    const [isValid, validationErrors] = await validatePassword({ password, passwordConfirmation });

    if (password !== passwordConfirmation) {
      setErrors(["Passwords must match"]);
      return;
    }

    if (isValid) {
      resetPassword(
        { password, passwordConfirmation, resetPasswordToken },
        {
          onSuccess: () => {
            setPassword("");
            setPasswordConfirmation("");
            setErrors(null);
            setResetPasswordToken(null);
            addToast({ title: `Password reset successfully`, kind: "success" });
            props.history.push(`/login`);
          },
          onError: (response: any) => {
            setErrors(response.data.errors);
          },
        },
      );
    } else {
      setErrors(validationErrors);
    }
  };

  const submitButton = (
    <SessionButton type="submit" loading={isLoading}>
      Reset password
    </SessionButton>
  );

  return (
    <SessionsLayout>
      <Styled.FormContentWrapper>
        <Styled.Form>
          <Helmet title="Reset password" />
          <FormLogoHeader />
          <h2>Reset password</h2>
          <FormContainer onSubmit={handleSubmitForm} errors={errors} buttons={submitButton}>
            <SessionFormInput
              onChange={handleFormInputChange}
              name="password"
              placeholder=""
              label="New password"
              inputType="password"
              value={password}
              errors={errors}
            />
            <SessionFormInput
              onChange={handleFormInputChange}
              name="passwordConfirmation"
              placeholder=""
              label="Confirm new password"
              inputType="password"
              value={passwordConfirmation}
              errors={errors}
            />
          </FormContainer>
        </Styled.Form>
        <Styled.Links>
          <Link to="/login">Log in by password</Link>
          <Link to="/auth">Log in by email link</Link>
        </Styled.Links>
      </Styled.FormContentWrapper>
    </SessionsLayout>
  );
}

export default withRouter(PasswordReset);
